import { render, staticRenderFns } from "./Wp_mini_my.vue?vue&type=template&id=17d39680&scoped=true&"
import script from "./Wp_mini_my.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_my.vue?vue&type=script&lang=js&"
import style0 from "./Wp_mini_my.vue?vue&type=style&index=0&id=17d39680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d39680",
  null
  
)

export default component.exports